module.exports = __webpack_public_path__ + "static/media/Comp 1_1.684a3604.gif";